import { render, staticRenderFns } from "./addProduceMould.pug?vue&type=template&id=797f43a9&scoped=true&lang=pug&"
import script from "./addProduceMould.ts?vue&type=script&lang=ts&"
export * from "./addProduceMould.ts?vue&type=script&lang=ts&"
import style0 from "./addProduceMould.styl?vue&type=style&index=0&id=797f43a9&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797f43a9",
  null
  
)

export default component.exports